export const SERVICE_FEE_RATE = 0.05;
